// ramp.ts
import { oklchHex, rgbToOklch } from './oklch';

export type Mode = 'light' | 'dark';

// Fixed lightness curves (0-based, 12 steps). Two separate curves: light vs dark.
export const LIGHT_L = [0.985, 0.965, 0.93, 0.885, 0.84, 0.78, 0.71, 0.63, 0.55, 0.5, 0.44, 0.3];
export const DARK_L = [
  0.175, 0.205, 0.245, 0.285, 0.33, 0.39, 0.455, 0.525, 0.62, 0.68, 0.745, 0.94,
];
// Chroma multiplier per step (fraction of the seed's chroma), peaking mid-scale.
export const C_CURVE = [0.06, 0.11, 0.2, 0.31, 0.44, 0.58, 0.72, 0.87, 1.0, 0.97, 0.88, 0.52];

// Radix-style step roles → 0-based index. State = fixed step index, not a formula.
export const STEP = {
  subtle: 0, // app / subtle background
  subtleHi: 1, // subtle bg hover
  componentHover: 2, // component bg hover on subtle
  componentActive: 3,
  line: 4, // subtle border
  border: 5, // default border
  borderStrong: 6, // strong border
  solidLow: 7,
  solid: 8, // solid fill (accent)
  solidHover: 9,
  solidActive: 10,
  text: 11, // text / high-contrast on light
} as const;

export function makeRamp(seed: string, mode: Mode): string[] {
  const { C, H } = rgbToOklch(seed);
  const Ls = mode === 'dark' ? DARK_L : LIGHT_L;
  const peak = Math.max(C, 0.02); // neutral seeds have ~0 chroma; keep a faint tint
  return Ls.map((L, i) => oklchHex(L, peak * C_CURVE[i], H));
}
